import { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Edit, Delete, DragIndicator } from '@mui/icons-material';
import { Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { IChecklistTemplateDetailMaterial } from '../../../models';

interface ICheckListMaterialProvided {
  setCurrentMaterialIndex: (val: number | null) => void;
  materialsProvided: IChecklistTemplateDetailMaterial[];
  setFieldValue: (key: string, val: any) => void;
  material: IChecklistTemplateDetailMaterial;
  itemIndex: number;
  isDragging: boolean;
}

export const CheckListMaterialProvided: FC<ICheckListMaterialProvided> = ({
  setFieldValue,
  itemIndex,
  materialsProvided,
  material,
  setCurrentMaterialIndex,
  isDragging
}) => {
  const classes = useStyles();
  return (
    <Card
      className={classes.card}
      sx={{
        backgroundColor: theme =>
          isDragging ? theme.palette.grey[300] : theme.palette.background.paper
      }}
    >
      <CardContent className={classes.cardContent}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs={1}>
            <DragIndicator color="action" />
          </Grid>
          <Grid item xs={3}>
            <Typography className={classes.bold}>Description</Typography>
            <Typography className={classes.value}>{material.description || '--'}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography className={classes.bold}>Manufacturer</Typography>
            <Typography className={classes.value}>{material.manufacturer}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography className={classes.bold}>Model</Typography>
            <Typography className={classes.value}>{material.model}</Typography>
          </Grid>
          <Grid item xs={3}>
            <div className={classes.actionButtons}>
              <Button
                color="primary"
                className={classes.editButton}
                startIcon={<Edit />}
                onClick={() => {
                  setCurrentMaterialIndex(itemIndex);
                }}
              >
                Edit
              </Button>
              <Button
                id="delete"
                className={classes.deleteButton}
                startIcon={<Delete />}
                onClick={async () => {
                  const result = window.confirm('Are you sure you want to delete this material?');
                  if (result) {
                    setFieldValue(
                      `materialsProvided`,
                      materialsProvided.filter(w => w.description !== material.description)
                    );
                  }
                }}
              >
                Delete
              </Button>
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  actionButtons: {
    textAlign: 'right',
    marginTop: 12,
    [theme.breakpoints.up('md')]: {
      marginTop: 0
    }
  },
  editButton: {
    textAlign: 'right',
    fontSize: 13
  },
  deleteButton: {
    marginLeft: theme.spacing(0.5),
    color: theme.palette.error.main
  },
  card: {
    width: '100%',
    marginTop: 8,
    marginBottom: 8,
    position: 'relative',
    zIndex: 1500
  },
  cardContent: {
    padding: `12px !important`
  },
  bold: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    fontSize: 12
  },
  value: {
    fontSize: 15
  }
}));
